import gql from "graphql-tag";

export const OrganizationFragment = gql`
fragment OrganizationFragment on OrganizationInterface {
    _id
    name
    type
    classType
    requireOverrideFields1
    veriflytID
}
`

export const CustomerFragment = gql`
    fragment CustomerFragment on Customer {
        _id
        name
        type
        classType
        requireOverrideFields1
        veriflytID
    }
`

export const TransporterFragment = gql`
    fragment TransporterFragment on Transporter {
        _id
        name
        type
        classType
        requireOverrideFields1
    }
`

export const EmployerFragment = gql`
    fragment EmployerFragment on Employer {
        _id
        name
        type
        classType
        requireOverrideFields1
        veriflytID
    }
`